import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../styles/general.css';

/**
 * Catch-all for undefined URLs.
 *
 * Without it, App.jsx matched no route for an unknown path and rendered an
 * empty document — a blank white page. That was worst for a signed-out user,
 * who got no navigation either and had no way out except editing the URL.
 */
const NotFoundPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="page-container text-center" data-testid="not-found-page">
      <h1>{t('common.notFoundTitle')}</h1>
      <p className="text-muted mb-20">{t('common.notFoundMessage')}</p>
      <button onClick={() => navigate('/dashboard')} className="btn btn-primary">
        {t('common.backToDashboard')}
      </button>
    </div>
  );
};

export default NotFoundPage;
